export type SupportPlatform = 'web' | 'ios' | 'android';

export type SupportContextParams = Record<string, string | undefined>;

export type SupportContextClientInput = {
  campaignId?: string;
  platform: SupportPlatform;
  route?: string;
  screen?: string;
  entityType?: string;
  entityId?: string;
  locale?: string;
  timezone?: string;
};

export function campaignIdFromParams(params: SupportContextParams): string | undefined {
  return params.projectId || params.campaignId || undefined;
}

export function buildSupportContextClientInput(args: {
  pathname: string;
  params: SupportContextParams;
  platform?: SupportPlatform;
  locale?: string;
  timezone?: string;
}): SupportContextClientInput {
  const entity = args.params.assignmentId
    ? { entityType: 'assignment', entityId: args.params.assignmentId, screen: 'Task assignment' }
    : args.params.activityId
      ? { entityType: 'task', entityId: args.params.activityId, screen: 'Task' }
      : args.params.templateResponseId
        ? {
            entityType: 'report',
            entityId: args.params.templateResponseId,
            screen: 'Report response',
          }
        : args.params.broadcastId
          ? { entityType: 'broadcast', entityId: args.params.broadcastId, screen: 'Broadcast' }
          : {};
  return {
    ...entity,
    campaignId: campaignIdFromParams(args.params),
    platform: args.platform ?? 'web',
    route: args.pathname,
    locale: args.locale,
    timezone: args.timezone,
  };
}
